export { ProjectCard } from './ProjectCard';
export type { ProjectCardProps, Project } from './ProjectCard';

